import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta" className="ground-highlighter sec-pad border-t border-[color:var(--ink)]">
      <div className="wrap">
        <div className="grid lg:grid-cols-12 gap-x-10 gap-y-8 items-center">
          <div className="lg:col-span-8">
            <p className="stamp mb-4" style={{ fontSize: 12 }}>The next step</p>
            <h2 className="h-section" style={{ fontSize: "clamp(28px, 3.6vw, 48px)", lineHeight: 1.08 }}>
              One business problem is enough to begin.
            </h2>
            <p className="font-body-serif measure mt-6" style={{ fontSize: 18, lineHeight: 1.65 }}>
              Tell us where your people need to perform differently. We will work with you to define the audience, target behaviour, programme scope and evidence of success.
            </p>
            <p className="font-body-serif mt-4" style={{ fontSize: 16, color: "#383D5A" }}>
              The first step is a discovery conversation leading to a scoped pilot.
            </p>
          </div>
          <div className="lg:col-span-4 lg:justify-self-end">
            <Link to="/contact" data-testid="final-cta-button" className="btn-ink">
              Start a discovery conversation <ArrowUpRight size={16} />
            </Link>
            <p className="stamp-dim mt-4" style={{ fontSize: 11 }}>hello@articulex.com · reply in 24 hours</p>
          </div>
        </div>
      </div>
    </section>
  );
}
